import { render, staticRenderFns } from "./DlvExL.vue?vue&type=template&id=2086e73a"
import script from "./DlvExL.vue?vue&type=script&lang=js"
export * from "./DlvExL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports